var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "crearMovimiento",
      attrs: { row: "", "justify-center": "" }
    },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivModulos" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "", disabled: _vm.btnBloquear },
                      on: {
                        click: function($event) {
                          _vm.dialogConfirmacionClose = true
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [_vm._v("Crear Movimiento")]),
                  _c("v-spacer"),
                  _c("v-toolbar-items", [
                    _vm.actual == 1
                      ? _c(
                          "div",
                          {
                            staticClass: "mt-2",
                            staticStyle: { height: "inherit" }
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                class: _vm.btnClass,
                                on: {
                                  click: function($event) {
                                    return _vm.nextGeneral()
                                  }
                                }
                              },
                              [_c("span", [_vm._v("Siguiente")])]
                            )
                          ],
                          1
                        )
                      : _vm.actual == 2
                      ? _c(
                          "div",
                          {
                            staticClass: "mt-2",
                            staticStyle: { height: "inherit" }
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "btn-volver mr-2",
                                on: {
                                  click: function($event) {
                                    return _vm.nextSerie("previous")
                                  }
                                }
                              },
                              [_c("span", [_vm._v("Volver")])]
                            ),
                            _c(
                              "v-btn",
                              {
                                class: _vm.btnClass,
                                on: {
                                  click: function($event) {
                                    return _vm.nextSerie("next")
                                  }
                                }
                              },
                              [_c("span", [_vm._v("Siguiente")])]
                            )
                          ],
                          1
                        )
                      : _vm.actual == 3
                      ? _c(
                          "div",
                          {
                            staticClass: "mt-2",
                            staticStyle: { height: "inherit" }
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "btn-volver mr-2",
                                on: {
                                  click: function($event) {
                                    return _vm.nextNoSerie("previous")
                                  }
                                }
                              },
                              [_c("span", [_vm._v("Volver")])]
                            ),
                            _c(
                              "v-btn",
                              {
                                class: _vm.btnClass,
                                on: {
                                  click: function($event) {
                                    return _vm.nextNoSerie("next")
                                  }
                                }
                              },
                              [_c("span", [_vm._v("Siguiente")])]
                            )
                          ],
                          1
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "mt-2",
                            staticStyle: { height: "inherit" }
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "btn-volver mr-2",
                                on: {
                                  click: function($event) {
                                    return _vm.CrearMovimientos("previous")
                                  }
                                }
                              },
                              [_c("span", [_vm._v("Volver")])]
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "btn-grabar",
                                on: {
                                  click: function($event) {
                                    return _vm.CrearMovimientos("next")
                                  }
                                }
                              },
                              [_c("span", [_vm._v("Guardar")])]
                            )
                          ],
                          1
                        )
                  ])
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c(
                "v-stepper",
                {
                  model: {
                    value: _vm.e1,
                    callback: function($$v) {
                      _vm.e1 = $$v
                    },
                    expression: "e1"
                  }
                },
                [
                  _c(
                    "v-stepper-header",
                    [
                      _c(
                        "v-stepper-step",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: true,
                              expression: "true"
                            }
                          ],
                          attrs: {
                            complete: _vm.e1 > _vm.generalMovi.step,
                            step: _vm.generalMovi.step
                          }
                        },
                        [_vm._v(_vm._s(_vm.generalMovi.accion))]
                      ),
                      _c("v-divider"),
                      _c(
                        "v-stepper-step",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: true,
                              expression: "true"
                            }
                          ],
                          attrs: {
                            complete: _vm.e1 > _vm.serieMovi.step,
                            step: _vm.serieMovi.step
                          }
                        },
                        [_vm._v(_vm._s(_vm.serieMovi.accion))]
                      ),
                      _c("v-divider"),
                      _c(
                        "v-stepper-step",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: true,
                              expression: "true"
                            }
                          ],
                          attrs: {
                            complete: _vm.e1 > _vm.noSerieMovi.step,
                            step: _vm.noSerieMovi.step
                          }
                        },
                        [_vm._v(_vm._s(_vm.noSerieMovi.accion))]
                      ),
                      _c("v-divider"),
                      _c(
                        "v-stepper-step",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: true,
                              expression: "true"
                            }
                          ],
                          attrs: {
                            complete: _vm.e1 == _vm.simMovi.step,
                            step: _vm.simMovi.step
                          }
                        },
                        [_vm._v(_vm._s(_vm.simMovi.accion))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-stepper-items",
                    { staticClass: "cardnew" },
                    [
                      _c(
                        "v-stepper-content",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.generalMovi.visible,
                              expression: "generalMovi.visible"
                            }
                          ],
                          attrs: { step: _vm.generalMovi.step }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { align: "center" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md10: "" } },
                                [
                                  _c("CrearGeneral", {
                                    ref: "CrearGeneral",
                                    attrs: {
                                      anuladoId: _vm.anuladoId,
                                      mostrarGeneral: true,
                                      despachos: _vm.despachos,
                                      estado: _vm.estadosSinAnulado,
                                      nuevoCodigo: _vm.nuevoCodigo,
                                      destinos: _vm.destinos,
                                      usuarioActivo: _vm.usuarioActivo,
                                      operaciones: _vm.operaciones
                                    },
                                    on: {
                                      CrearMovimientos: _vm.CrearMovimientos
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "v-stepper-content",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.serieMovi.visible,
                              expression: "serieMovi.visible"
                            }
                          ],
                          attrs: { step: _vm.serieMovi.step }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { align: "center" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md10: "" } },
                                [
                                  _c(
                                    "v-card",
                                    { staticClass: "rounded-card" },
                                    [
                                      _c("TablaSerie", {
                                        ref: "dispositivosSeriados",
                                        attrs: {
                                          mostrarSerie: true,
                                          nuevoCodigo: _vm.nuevoCodigo,
                                          usuarioActivo: _vm.usuarioActivo,
                                          equipos: _vm.equipos,
                                          requerimientos: _vm.requerimientos,
                                          clientes: _vm.clientes
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "v-stepper-content",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.noSerieMovi.visible,
                              expression: "noSerieMovi.visible"
                            }
                          ],
                          attrs: { step: _vm.noSerieMovi.step }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { align: "center" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md10: "" } },
                                [
                                  _c(
                                    "v-card",
                                    { staticClass: "rounded-card" },
                                    [
                                      _c("TablaNoSeriada", {
                                        ref: "dispositivosNoSeriados",
                                        attrs: {
                                          mostrarNoSerie: true,
                                          usuarioActivo: _vm.usuarioActivo,
                                          nuevoCodigo: _vm.nuevoCodigo,
                                          equipos: _vm.equipos,
                                          requerimientos: _vm.requerimientos,
                                          clientes: _vm.clientes
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "v-stepper-content",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.simMovi.visible,
                              expression: "simMovi.visible"
                            }
                          ],
                          attrs: { step: _vm.simMovi.step }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { align: "center" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md10: "" } },
                                [
                                  _c(
                                    "v-card",
                                    { staticClass: "rounded-card" },
                                    [
                                      _c("TablaSim", {
                                        ref: "dispositivosSim",
                                        attrs: {
                                          mostrarSim: true,
                                          usuarioActivo: _vm.usuarioActivo,
                                          nuevoCodigo: _vm.nuevoCodigo,
                                          telcos: _vm.telcos,
                                          estados: _vm.estados
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.crear.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.crear.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }